import axios from 'axios';

const API_BASE = '/api/dashboard';

export const dashboardService = {
  getActivityFeed: async (params = {}, axiosConfig = {}) => {
    const response = await axios.get(`${API_BASE}/activity-feed`, { params, ...axiosConfig });
    return response.data;
  },
  getQuoteActivity: async (params = {}, axiosConfig = {}) => {
    const response = await axios.get(`${API_BASE}/quote-activity`, { params, ...axiosConfig });
    return response.data;
  },
  getOrderActivity: async (params = {}, axiosConfig = {}) => {
    const response = await axios.get(`${API_BASE}/order-activity`, { params, ...axiosConfig });
    return response.data;
  },
  getPurchaseOrderActivity: async (params = {}, axiosConfig = {}) => {
    const response = await axios.get(`${API_BASE}/po-activity`, { params, ...axiosConfig });
    return response.data;
  },
  getShipmentInActivity: async (params = {}, axiosConfig = {}) => {
    const response = await axios.get(`${API_BASE}/shipment-in-activity`, { params, ...axiosConfig });
    return response.data;
  },
  getVendorInvoiceActivity: async (params = {}, axiosConfig = {}) => {
    const response = await axios.get(`${API_BASE}/vendor-invoice-activity`, { params, ...axiosConfig });
    return response.data;
  }
};
